// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VoiceHistogram__container-cbdf20 {
  --histogram-height: 24px;
  --bar-color: #aba9a9;
  --bar-progress-color: var(--brand-primary-40);
}

.VoiceHistogram__container-cbdf20.VoiceHistogram__histogram-theme-chat-b96c48 {
  --bar-color: var(--chat-bubble-text-secondary);
  --bar-progress-color: var(--chat-bubble-primary);
}

.VoiceHistogram__bars-d9bdd1 {
  cursor: pointer;
  height: var(--histogram-height);
  fill: var(--addition-150);
}

.VoiceHistogram__bar-color-b336cf {
  stop-color: var(--bar-color);
}

.VoiceHistogram__bar-progress-color-eeab94 {
  stop-color: var(--bar-progress-color);
}`, "",{"version":3,"sources":["webpack://./src/components/VoiceHistogram/VoiceHistogram.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,oBAAA;EACA,6CAAA;AACF;;AAEA;EACE,8CAAA;EACA,gDAAA;AACF;;AAEA;EACE,eAAA;EACA,+BAAA;EACA,yBAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,qCAAA;AACF","sourcesContent":[".container {\n  --histogram-height: 24px;\n  --bar-color: #aba9a9;\n  --bar-progress-color: var(--brand-primary-40);\n}\n\n.container.histogram-theme-chat {\n  --bar-color: var(--chat-bubble-text-secondary);\n  --bar-progress-color: var(--chat-bubble-primary);\n}\n\n.bars {\n  cursor: pointer;\n  height: var(--histogram-height);\n  fill: var(--addition-150);\n}\n\n.bar-color {\n  stop-color: var(--bar-color);\n}\n\n.bar-progress-color {\n  stop-color: var(--bar-progress-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VoiceHistogram__container-cbdf20`,
	"histogram-theme-chat": `VoiceHistogram__histogram-theme-chat-b96c48`,
	"histogramThemeChat": `VoiceHistogram__histogram-theme-chat-b96c48`,
	"bars": `VoiceHistogram__bars-d9bdd1`,
	"bar-color": `VoiceHistogram__bar-color-b336cf`,
	"barColor": `VoiceHistogram__bar-color-b336cf`,
	"bar-progress-color": `VoiceHistogram__bar-progress-color-eeab94`,
	"barProgressColor": `VoiceHistogram__bar-progress-color-eeab94`
};
module.exports = ___CSS_LOADER_EXPORT___;
